import React from 'react';
import './ChartSelector.scss';

interface Props {
  value: any;
  disabled?: boolean;
  options: any[];
  onChange: (val: any) => void;
}
const ChartSelector: React.FC<Props> = (props) => {

  const opts = props.options
  const val = props.value
  const type = val.type || opts[0].type

  const disabled = props.disabled
  const renderItem = (item, index) => {
    const selected = type === item.type
    return (
      <div 
        key={index} 
        onClick={disabled ? undefined : () => props.onChange(item)}
        className={[
          "chart-selector-item",
          selected ? "selected" : "",
          disabled ? "disabled" : ""
        ].join(' ')}>
        {item.title}
      </div>
    )
  }

  return (
    <div className={"chart-selector"}>
      {opts.map(renderItem)}
    </div>
  );
}

export default ChartSelector;
